interface LogoProps {
  className?: string
}

/**
 * Mesa circle mark -- Badland logomark (inline SVG for CSS color inheritance).
 * Decorative everywhere it is used, so it stays out of the accessibility tree.
 *
 * Keep the transform and the two paths as literals: the native apps' mark is
 * generated from this file (apps/ios/scripts/generate-mark.py reads them), and
 * the ember scene samples the same paths from lib/brand/markPaths, which
 * BadlandLogo.test.tsx keeps identical to these.
 */
export function BadlandMark({ className }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 384"
      fill="currentColor"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <g transform="translate(16,384) scale(0.1,-0.1)">
        <path d="M1652 3069 c-132 -12 -269 -51 -397 -113 -243 -119 -411 -287 -531 -531 -333 -682 65 -1483 816 -1641 106 -22 326 -25 425 -5 78 15 248 72 310 103 158 80 356 254 447 393 135 207 192 396 192 635 0 149 -18 265 -61 383 -183 514 -660 822 -1201 776z m279 -134 c346 -60 633 -286 776 -610 59 -136 78 -232 78 -410 0 -143 -3 -170 -28 -258 -33 -122 -81 -225 -146 -320 -61 -88 -96 -124 -103 -105 -3 7 -20 97 -39 201 -28 156 -37 187 -51 187 -24 0 -30 -13 -54 -110 l-21 -85 -6 120 c-4 66 -10 159 -13 206 l-6 87 -56 11 c-30 6 -59 11 -63 11 -5 0 -10 -109 -11 -242 l-3 -243 -29 145 c-15 80 -43 228 -61 329 -18 100 -37 187 -42 191 -4 5 -41 10 -82 12 l-75 3 -37 -172 c-20 -94 -39 -177 -42 -185 -3 -7 -6 147 -6 344 l-1 356 -32 11 c-17 6 -35 8 -39 4 -3 -5 -14 -78 -24 -163 -10 -85 -20 -150 -22 -145 -1 6 -11 95 -22 199 -11 104 -24 193 -30 199 -9 9 -385 6 -395 -4 -3 -2 -15 -65 -28 -139 l-23 -135 -85 -45 -85 -45 -33 -270 -33 -270 -62 -57 c-34 -32 -64 -58 -67 -58 -9 0 -58 139 -77 215 -13 51 -17 112 -17 225 0 138 3 166 27 254 97 354 338 610 683 725 151 51 328 64 485 36z m-581 -764 c0 -137 3 -258 6 -268 5 -12 4 -15 -3 -8 -5 6 -25 86 -43 179 -25 134 -31 183 -25 230 12 107 15 116 41 116 l24 0 0 -249z m-120 -387 c16 -153 31 -294 33 -312 3 -31 -4 -39 -125 -142 -70 -61 -129 -110 -132 -110 -10 0 -116 142 -116 155 0 8 36 44 79 81 51 43 81 77 84 93 3 14 13 100 23 190 10 90 20 159 22 152 2 -7 14 -81 26 -164 27 -179 28 -176 52 125 10 120 19 216 21 214 2 -2 17 -129 33 -282z m425 -524 c31 -91 60 -169 65 -173 4 -5 29 17 55 47 26 31 51 56 55 56 4 0 38 -40 76 -90 77 -103 57 -96 246 -79 65 6 121 9 123 7 9 -9 -195 -91 -274 -111 -70 -17 -115 -21 -241 -21 -136 1 -167 4 -255 27 -55 15 -145 49 -200 76 -93 46 -234 143 -242 167 -8 23 209 112 372 153 30 8 53 25 94 72 39 44 56 57 61 48 4 -8 33 -88 65 -179z" />
        <path d="M2256 2558 c-14 -93 -78 -158 -169 -174 -47 -7 -40 -15 34 -37 75 -23 108 -60 130 -144 15 -62 18 -65 24 -38 14 63 36 113 63 138 28 27 99 57 133 57 37 0 18 15 -33 28 -87 20 -129 62 -150 147 -16 68 -24 74 -32 23z" />
      </g>
    </svg>
  )
}

interface WordmarkProps {
  className?: string
}

/** BADLAND in the display face, the way the front page sets it. */
export function BadlandWordmark({ className }: WordmarkProps) {
  return (
    <span
      className={`select-none font-[family-name:var(--bl-font-display)] font-extrabold uppercase tracking-[0.16em] text-[color:var(--bl-gold-text)] ${className ?? ''}`}
    >
      Badland
    </span>
  )
}
